import React from "react"
import AppDialog from "../../components/Common/AppDialog"

import '../Orders/order.css';
import { Grid } from "@mui/material";
import Helpers from "../../helpers/helpers";

const MarkResolved = (props) => {

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={`Mark as ${props?.type ? props.type : "Resolved"}`}
            titleIcon={'complete'}
            positiveTitle={`Mark as ${props?.type ? props.type : "Resolved"}`}
            positivePress={() => props.submit()}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'40%'}
        >
            <Grid container spacing={2}>
                <Grid item sm={12}>
                    Are you sure you want to mark this {props?.module ? props.module : "inquiry"} as {props?.type === "Closed" ? "closed" : "resolved"}?
                </Grid>
                {!props?.module && <>
                    <Grid item sm={6}>Inquiry type</Grid>
                    <Grid item sm={6} className="text-bold">{props?.selectedInquiry?.inquiry_type ? Helpers?.convertToCustomTitleCase(props?.selectedInquiry?.inquiry_type) : "-"}</Grid>
                </>}
                {
                    props?.selectedInquiry?.return_preference &&
                    <Grid item sm={6}>Return preference</Grid>
                }
                {
                    props?.selectedInquiry?.return_preference &&
                    <Grid item sm={6} className="text-bold">{props?.selectedInquiry?.return_preference ? Helpers?.convertToCustomTitleCase(props?.selectedInquiry?.return_preference) : "-"}</Grid>
                }
            </Grid>
        </AppDialog>
    )
}

export default MarkResolved;